import 'promise-polyfill/src/polyfill';
import axios from 'axios';
import Stepper from 'bs-stepper';

(function(oryxGlobals) {
	let stepper;
	const templateUrl = oryxGlobals.templateUrl;
	const adminUrl = oryxGlobals.adminUrl;
	const selectedOptionsForString = oryxGlobals.selectedOptionsFor;

	const disableButtons = buttons => {
		Array.from(buttons).forEach(button => (button.disabled = true));
	};

	const enableButtons = buttons => {
		Array.from(buttons).forEach(button => (button.disabled = false));
	};

	const getProductNameSummaryHtml = function() {
		const productNameElement = document.querySelector('.c-quotationForm__productName');
		let productName = '';
		let templateString = '';

		if (productNameElement && typeof productNameElement === 'object') {
			productName = productNameElement.innerHTML;

			if (productName.length) {
				templateString = '<div class="c-quotationFormSummary c-quotationFormSummary--product">';
				templateString += '<h2 class="c-quotationFormSummary__title mb-0">' + productName + '</h2>';
				templateString += '</div>';
			}
		}

		return templateString;
	};

	const getOptionsSummaryHtml = function() {
		const checkedElements = document.querySelectorAll('#options-part :checked');
		const productName = document.querySelector('input[name=product]');
		const checkboxIcon = `<svg class="o-icon" aria-hidden="true" focusable="false">
														<use xlink:href="${templateUrl}/assets/images/icon-sprite.svg#checkbox-marked-outline"></use>
													</svg>`;

		let templateString = '<div class="c-quotationFormSummary c-quotationFormSummary--options">';
		let productNameString = '';
		if (productName && productName.value) {
			productNameString = '<strong>' + productName.value + '</strong>';
		}

		templateString += '<h2 class="c-quotationFormSummary__title">' + selectedOptionsForString + ' ' + productNameString + '</h2>';

		templateString += '<div id="summary-options">';

		Array.from(checkedElements).forEach(element => {
			const label = element.nextSibling;
			const depth = parseInt(label.dataset.depth, 10);
			const cssClass = 'level-' + depth;
			let prefix = '';

			if (depth === 0) {
				prefix = checkboxIcon;
			}

			templateString += `<p class="${cssClass}">${prefix}${label.innerHTML}</p>`;
		});

		templateString += '</div>';

		templateString += '</div>';

		return templateString;
	};

	const getTransportSummaryHtml = function() {
		let templateString = '<div class="c-quotationFormSummary c-quotationFormSummary--transportation">';
		const deliveryService = document.querySelector('#transport-part input[name=delivery]:checked');
		const province = document.querySelector('#province').value;
		const address = document.querySelector('#address').value;
		const city = document.querySelector('#city').value;
		const country = document.querySelector('#country').value;

		templateString += '<h2 class="c-quotationFormSummary__title">Transportation</h2>';

		if (deliveryService) {
			templateString += `<p><strong>Delivery Service:</strong> ${deliveryService.value}</p>`;
		}

		if (deliveryService.value === 'shipping') {
			if (province.length) {
				templateString += `<p><strong>Province:</strong> ${province}</p>`;
			}

			if (address.length) {
				templateString += `<p><strong>Postal Address:</strong> ${address}</p>`;
			}

			if (city.length) {
				templateString += `<p><strong>City:</strong> ${city}</p>`;
			}

			if (country.length) {
				templateString += `<p><strong>Country:</strong> ${country}</p>`;
			}
		}

		templateString += '</div>';

		return templateString;
	};

	const onStep = function(e) {
		const index = e.detail.indexStep;
		const summaryElement = document.getElementById('summary-wrapper');

		// Index of the summary step
		if (index === 2) {
			summaryElement.innerHTML = getProductNameSummaryHtml() + getOptionsSummaryHtml() + getTransportSummaryHtml();
		}
	};

	const handleStepElementClick = function(e) {
		const element = e.target;
		const direction = element.dataset.step;

		if (direction === 'next') {
			stepper.next();
		} else if (direction === 'previous') {
			stepper.previous();
		}
	};

	const initStepper = function() {
		const stepperElement = document.querySelector('.bs-stepper');

		if (stepperElement) {
			stepper = new Stepper(stepperElement, {
				linear: false,
				animation: true
			});

			const stepperNavigationElements = stepperElement.querySelectorAll('button[data-step]');

			if (stepperNavigationElements && stepperNavigationElements.length) {
				Array.from(stepperNavigationElements).forEach(element => element.addEventListener('click', handleStepElementClick));
			}

			stepperElement.addEventListener('show.bs-stepper', onStep);
		}
	};

	const handleDeliveryMethodChange = function(e) {
		const deliveryMethod = e.target.value;
		const shippingDetailsElement = document.getElementById('shipping-details');

		if (deliveryMethod === 'shipping') {
			shippingDetailsElement.classList.add('is-active');
		} else {
			shippingDetailsElement.classList.remove('is-active');
		}
	};

	const bindEvents = () => {
		const deliveryMethodInputs = document.querySelectorAll('input[name=delivery]');

		if (deliveryMethodInputs && deliveryMethodInputs.length) {
			Array.from(deliveryMethodInputs).forEach(input => input.addEventListener('change', handleDeliveryMethodChange));
		}
	};

	const quotationForm = () => {
		initStepper();
		bindEvents();

		const handleCheckboxStateChange = function(e) {
			const parent = e.target.parentNode;

			if (typeof parent !== 'undefined' && parent !== null) {
				parent.classList.toggle('is-selected');

				// Clear related descendant fields when unchecking checkboxes
				if (!parent.classList.contains('is-selected')) {
					const checkedInputs = parent.nextSibling && parent.nextSibling.querySelectorAll('input:checked');
					const isSelectedElements = parent.nextSibling && parent.nextSibling.querySelectorAll('.is-selected');

					if (checkedInputs && checkedInputs.length) {
						Array.from(checkedInputs).forEach(input => (input.checked = false));
					}

					if (isSelectedElements && isSelectedElements.length) {
						Array.from(isSelectedElements).forEach(element => element.classList.remove('is-selected'));
					}
				}
			}
		};

		const quotationFormElement = document.getElementById('quotation-form');
		const quotationFormOptionsElement = document.getElementById('options-part');

		if (quotationFormElement && quotationFormElement.length > 0) {
			const checkboxes = quotationFormOptionsElement.querySelectorAll('[type=checkbox]');
			document.body.classList.add('single-quotation');

			if (checkboxes && checkboxes.length) {
				Array.from(checkboxes).forEach(checkbox => checkbox.addEventListener('change', handleCheckboxStateChange));
			}

			quotationFormElement.addEventListener('submit', e => {
				e.preventDefault();

				const buttons = document.querySelectorAll('#quotation-form button');
				const submitBtn = document.querySelector('#quotation-form button[type=submit]');
				const formData = new window.FormData(quotationFormElement);
				const optionsSummaryHtml = document.getElementById('summary-options').innerHTML;

				formData.append('action', 'quotation_request');
				formData.append('options-summary-html', optionsSummaryHtml);

				disableButtons(buttons);
				submitBtn.classList.add('has-loader');

				axios
					.post(`${adminUrl}admin-ajax.php`, formData)
					.then(response => {
						enableButtons(buttons);
						submitBtn.classList.remove('has-loader');
						const responseMessage = response.data.data;

						if (response.data.success) {
							document.getElementById('quotation-success-content').innerHTML = responseMessage;
							document.body.classList.add('is-successfullySent');
							document.body.classList.remove('is-quotationFormError');
						} else {
							document.getElementById('quotation-error-content').innerHTML = responseMessage;
							document.body.classList.add('is-quotationFormError');
							document.body.classList.remove('is-successfullySent');

							const resetBtn = document.querySelector('.qf-hide-error');
							if (resetBtn) {
								resetBtn.addEventListener('click', function(e) {
									e.preventDefault();
									document.body.classList.remove('is-quotationFormError');
								});
							}
						}
					})
					.catch(function(err) {
						console.error(err);
						enableButtons(buttons);
						submitBtn.classList.remove('has-loader');
					});
			});
		}
	};

	document.addEventListener('DOMContentLoaded', quotationForm);
})(window.oryxGlobals);
